class Constants {

    static True = '1';
  
    static Sales = 1;
    static Service = 2;
    static RealEstate = 3;
    static HelpDesk = 4;
    static Ticket = 5;

    static LoggedIn =  'logged-in';
    static Auth =  'auth';
    static Type =  'type';
    
    static ProcessAPI = (res, success, error) => {
      if(res.status === 200) { res.json().then(result => success(result)); }
      else { res.json().then(err => error(err)); }
    }
  }
  export default Constants;